module.exports = __webpack_public_path__ + "img/result_chara.63afb81e.png";